import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import "./styles/globals.scss"
import "./styles/theme.scss"
import "react-multi-carousel/lib/styles.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

